export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
// Property landing page (info/overview)
export const BOOKING_URL =
  "https://www.bestwestern.com/en_US/book/hotels-in-joliet/best-western-joliet-inn-suites/propertyCode.14155.html";
// Rooms / rate selection page — accepts checkInDate, checkOutDate, guests, rooms query params (YYYY-MM-DD)
export const BOOKING_ROOMS_URL =
  "https://www.bestwestern.com/en_US/book/joliet/hotel-rooms/best-western-joliet-inn-suites/propertyCode.14155.html";
